import { ComplexValue, LoadOptions } from 'app/types-shared';
import {
  ExternalUrlGroupItem, ExternalUrlGroupsItemValidation,
  ExternalUrlItem, ExternalUrlsValidation, ExternalUrlValidation, AccessPolicyValue,
  ExternalUrlValue
} from './types-store';
import { ValidationProps } from 'ui';
import { AddExternalUrlType } from 'app/area/external-url-groups/form/types';

export const ACTION = {
  REQUEST_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:REQUEST_EXTERNAL_URL_GROUP',
  RECEIVE_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:RECEIVE_EXTERNAL_URL_GROUP',
  FAIL_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:FAIL_EXTERNAL_URL_GROUP',

  REQUEST_DELETE_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:REQUEST_DELETE_EXTERNAL_URL_GROUP',
  RECEIVE_DELETE_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:RECEIVE_DELETE_EXTERNAL_URL_GROUP',
  FAIL_DELETE_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:FAIL_DELETE_EXTERNAL_URL_GROUP',

  REQUEST_SAVE_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:REQUEST_SREQUEST_SAVE_EXTERNAL_URL_GROUPAVE_EXTERNAL_URL',
  RECEIVE_SAVE_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:RECEIVE_SAVE_EXTERNAL_URL_GROUP',
  FAIL_SAVE_EXTERNAL_URL_GROUP: 'EXTERNAL_URL_GROUPS_FORM:FAIL_SAVE_EXTERNAL_URL_GROUP',

  UPDATE_ITEM: 'EXTERNAL_URL_GROUPS_FORM:UPDATE_ITEM',

  CHANGE_LANGUAGE: 'EXTERNAL_URL_GROUPS_FORM:CHANGE_LANGUAGE',
  COPY_LANGUAGE_TO_ALL: 'EXTERNAL_URL_GROUPS_FORM:COPY_LANGUAGE_TO_ALL',

  CHANGE_LONG_DESCRIPTION: 'EXTERNAL_URL_GROUPS_FORM: CHANGE_LONG_DESCRIPTION',
  COPY_LONG_DESCRIPTION_TO_ALL: 'EXTERNAL_URL_GROUPS_FORM:COPY_LONG_DESCRIPTION_TO_ALL',

  UPDATE_ACCESS_POLICY_ITEM: 'EXTERNAL_URL_GROUPS_FORM:UPDATE_ACCESS_POLICY_ITEM',
  REMOVE_ACCESS_POLICY: 'EXTERNAL_URL_GROUPS_FORM:REMOVE_ACCESS_POLICY',
  REMOVE_ALL_ACCESS_POLICIES: 'EXTERNAL_URL_GROUPS_FORM:REMOVE_ALL_ACCESS_POLICIES',
  ADD_ACCESS_POLICY: 'EXTERNAL_URL_GROUPS_FORM:ADD_ACCESS_POLICY',
  UPDATE_ACCESS_POLICY_VALIDATION: 'EXTERNAL_URL_GROUPS_FORM:UPDATE_ACCESS_POLICY_VALIDATION',
  RESET_ACCESS_POLICY_CLIENT_VALIDATION: 'EXTERNAL_URL_GROUPS_FORM:RESET_ACCESS_POLICY_CLIENT_VALIDATION',
  RESET_ACCESS_POLICY_SERVER_VALIDATION: 'EXTERNAL_URL_GROUPS_FORM:RESET_ACCESS_POLICY_SERVER_VALIDATION',
  RESET_ALL_ACCESS_POLICY_VALIDATION: 'EXTERNAL_URL_GROUPS_FORM:RESET_ALL_ACCESS_POLICY_VALIDATION',

  REQUEST_ADD_EXTERNAL_URLS: 'EXTERNAL_URL_GROUPS_FORM:REQUEST_ADD_EXTERNAL_URLS',
  RECEIVE_ADD_EXTERNAL_URLS: 'EXTERNAL_URL_GROUPS_FORM:RECEIVE_ADD_EXTERNAL_URLS',
  FAIL_ADD_EXTERNAL_URLS: 'EXTERNAL_URL_GROUPS_FORM:FAIL_ADD_EXTERNAL_URLS',

  UPDATE_EXTERNAL_URL_ITEM: 'EXTERNAL_URL_GROUPS_FORM:UPDATE_EXTERNAL_URL_ITEM',
  UPDATE_EXTERNAL_URLS_VALIDATION: 'EXTERNAL_URL_GROUPS_FORM:UPDATE_EXTERNAL_URLS_VALIDATION',

  DELETE_EXTERNAL_URL: 'EXTERNAL_URL_GROUPS_FORM:DELETE_EXTERNAL_URL',
  DELETE_ALL_EXTERNAL_URLS: 'EXTERNAL_URL_GROUPS_FORM:DELETE_ALL_EXTERNAL_URLS',

  REQUEST_LANGUAGE_OPTIONS: 'EXTERNAL_URL_GROUPS_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'EXTERNAL_URL_GROUPS_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'EXTERNAL_URL_GROUPS_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_EXTERNAL_URL_OPTIONS: 'EXTERNAL_URL_GROUPS_FORM:REQUEST_EXTERNAL_URL_OPTIONS',
  RECEIVE_EXTERNAL_URL_OPTIONS: 'EXTERNAL_URL_GROUPS_FORM:RECEIVE_EXTERNAL_URL_OPTIONS',
  FAIL_EXTERNAL_URL_OPTIONS: 'EXTERNAL_URL_GROUPS_FORM:FAIL_EXTERNAL_URL_OPTIONS',

  CLEAR_FORM: 'EXTERNAL_URL_GROUPS_FORM:CLEAR_FORM',
  UPDATE_VALIDATION: 'EXTERNAL_URL_GROUPS_FORM:UPDATE_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestExternalUrlOptions {
  public type: string = ACTION.REQUEST_EXTERNAL_URL_OPTIONS;
  constructor(public query: string, public loadOptionsParams: LoadOptions) {
  }
}

export class ReceiveExternalUrlOptions {
  public type: string = ACTION.RECEIVE_EXTERNAL_URL_OPTIONS;
  constructor(public query: string, public values: ExternalUrlValue[]) {
  }
}

export class FailExternalUrlOptions {
  public type: string = ACTION.FAIL_EXTERNAL_URL_OPTIONS;
  constructor(public query: string) {
  }
}

export class RequestExternalUrlGroup {
  public type: string = ACTION.REQUEST_EXTERNAL_URL_GROUP;
}

export class ReceiveExternalUrlGroup {
  public type: string = ACTION.RECEIVE_EXTERNAL_URL_GROUP;
  constructor(
    public item: ExternalUrlGroupItem
  ) { }
}

export class FailExternalUrlGroup {
  public type: string = ACTION.FAIL_EXTERNAL_URL_GROUP;
}

export class RequestDeleteExternalUrlGroup {
  public type: string = ACTION.REQUEST_DELETE_EXTERNAL_URL_GROUP;
}

export class ReceiveDeleteExternalUrlGroup {
  public type: string = ACTION.RECEIVE_DELETE_EXTERNAL_URL_GROUP;
}

export class FailDeleteExternalUrlGroup {
  public type: string = ACTION.FAIL_DELETE_EXTERNAL_URL_GROUP;
}

export class RequestSaveExternalUrlGroup {
  public type: string = ACTION.REQUEST_SAVE_EXTERNAL_URL_GROUP;
}

export class ReceiveSaveExternalUrlGroup {
  public type: string = ACTION.RECEIVE_SAVE_EXTERNAL_URL_GROUP;
}

export class FailSaveExternalUrlGroup {
  public type: string = ACTION.FAIL_SAVE_EXTERNAL_URL_GROUP;
}

export class UpdateAccessPolicyItem {
  public type: string = ACTION.UPDATE_ACCESS_POLICY_ITEM;
  constructor(public accessPolicyValue: AccessPolicyValue) { }
}

export class RemoveAccessPolicy {
  public type: string = ACTION.REMOVE_ACCESS_POLICY;
  constructor(public id: number) {
  }
}

export class RemoveAllAccessPolicies {
  public type: string = ACTION.REMOVE_ALL_ACCESS_POLICIES;
}

export class AddAccessPolicy {
  public type: string = ACTION.ADD_ACCESS_POLICY;
}

export class UpdateAccessPolicyValidation {
  public type: string = ACTION.UPDATE_ACCESS_POLICY_VALIDATION;
  constructor(public id: number, public validationProps: { [propertyName: string]: ValidationProps }) { }
}

export class ResetAccessPolicyClientValidation {
  public type: string = ACTION.RESET_ACCESS_POLICY_CLIENT_VALIDATION;
  constructor(public id: number, public key?: keyof AccessPolicyValue) {
  }
}

export class ResetAccessPolicyServerValidation {
  public type: string = ACTION.RESET_ACCESS_POLICY_SERVER_VALIDATION;
  constructor(public id: number) {
  }
}

export class ResetAllAccessPolicyValidation {
  public type: string = ACTION.RESET_ALL_ACCESS_POLICY_VALIDATION;
}

export class RequestAddExternalUrls {
  public type: string = ACTION.REQUEST_ADD_EXTERNAL_URLS;
}

export class ReceiveAddExternalUrls {
  public type: string = ACTION.RECEIVE_ADD_EXTERNAL_URLS;
  constructor(
    public addType: AddExternalUrlType,
    public externalUrls: ExternalUrlItem[],
    public sequence: number,
    public normalizeSequence: (items: ExternalUrlItem[]) => ExternalUrlItem[]
  ) { }
}

export class FailAddExternalUrls {
  public type: string = ACTION.FAIL_ADD_EXTERNAL_URLS;

}

export class UpdateExternalUrlItem {
  public type: string = ACTION.UPDATE_EXTERNAL_URL_ITEM;
  constructor(
    public id: number,
    public externalUrl: ExternalUrlItem,
    public validation: ExternalUrlValidation,
    public normalizeSequence: (externalUrls: ExternalUrlItem[]) => ExternalUrlItem[]
  ) { }
}

export class DeleteExternalUrl {
  public type: string = ACTION.DELETE_EXTERNAL_URL;
  constructor(
    public externalUrlId: number,
    public normalizeSequence: (externalUrls: ExternalUrlItem[]) => ExternalUrlItem[]
  ) { }
}

export class DeleteAllExternalUrls {
  public type: string = ACTION.DELETE_ALL_EXTERNAL_URLS;

}

export class UpdateExternalUrlsValidation {
  public type: string = ACTION.UPDATE_EXTERNAL_URLS_VALIDATION;
  constructor(
    public validation: ExternalUrlsValidation
  ) { }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<ExternalUrlGroupItem>) { }
}

export class ChangeLanguage {
  public type: string = ACTION.CHANGE_LANGUAGE;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLanguageToAll {
  public type: string = ACTION.COPY_LANGUAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class ChangeLongDescription {
  public type: string = ACTION.CHANGE_LONG_DESCRIPTION;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLongDescriptionToAll {
  public type: string = ACTION.COPY_LONG_DESCRIPTION_TO_ALL;
  constructor(public languageId: number) { }
}
export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: ExternalUrlGroupsItemValidation) { }
}
